import angular from 'angular';
import constants from 'app/constants';
import {
  assetDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './bulk-delete-controls-confirm-dialog.controller';
import template from './bulk-delete-controls-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, controls,
    updateCallBack,
  }) {
    return {
      controller,
      controllerAs: 'deleteConfirmDialogVM',
      locals: {
        customerId,
        controls,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.control.bulkDeleteControlsConfirmDialog', [
  alerts,
  assetDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('bulkDeleteControlsConfirmDialog', dialogService)
  .name;
